import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Heading from '../../../../common/element/Heading';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import AddEdit from './AddEdit';
import ManagementList from './ManagementList';
import ImportManagement from './ImportCsv';
import {

  selectManagementsList,
  selectManagementsListLoading,
  selectManagementsListError,
  selectManagementsListTotal
} from '../../../../redux/Managment/managmentSelector';
import {
  getManagementsList,

} from '../../../../redux/Managment/mangmentSlice';
import { selectUserData } from '../../../../redux/auth/authSelector';
import { ROLES } from '../../../../config/rolePermissions';
import { useLocation } from 'react-router-dom';

const Management = ({ companyData }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const rawCompanyId = searchParams.get("companyId");
  console.log(rawCompanyId, "rawCompanyIdrawCompanyId")
  // Redux selectors
  const managementsData = useSelector(selectManagementsList);
  const loading = useSelector(selectManagementsListLoading);
  const error = useSelector(selectManagementsListError);
  const totalCount = useSelector(selectManagementsListTotal);

  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [selectedManagement, setSelectedManagement] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const userData = useSelector(selectUserData);
  const isAdmin = userData?.role_name === ROLES.ADMIN;
  const isActiveCompany = companyData?.hasOwnProperty('company_isActive') ? companyData?.company_isActive : userData?.company_isActive;

  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    // sort: "created_date",
    // order: "desc",
    search: "",
  });

  // Fetch managements list
  const fetchManagementsList = useCallback(() => {
    dispatch(getManagementsList({

      page: getFilterData.page,
      limit: getFilterData.limit,
      search: getFilterData.search,
      sort: getFilterData.sort,
      order: getFilterData.order,
      company_id: rawCompanyId
    }));
  }, [dispatch, getFilterData]);

  // Initial fetch and when filters change
  useEffect(() => {
    fetchManagementsList();
  }, [fetchManagementsList]);

  // Update total pages when data changes
  useEffect(() => {
    if (totalCount > 0) {
      setTotalPages(Math.ceil(totalCount / filterlimit));
    }
  }, [totalCount, filterlimit]);

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        page: 1, // Reset to first page on search
        [e.target.name]: e.target.value.trim(),
      };
    });
    setfilterpage(1); // Reset page number
  };

  useEffect(() => {
    // If we're inside a company view (companyId present in query) don't override
    // the company breadcrumbs. Only set the standalone Management breadcrumb
    // when this page is accessed directly (no company context).
    if (!rawCompanyId) {
      dispatch(
        setBreadcrumbs([
          {
            label: "Management",
            url: "/management",
            home: "/companies",
          },
        ])
      );
    }
  }, [dispatch]);

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  const handlePageChange = (page) => {
    setfilterpage(page);
    SetFilterData((prev) => ({
      ...prev,
      page: page
    }));
  };

  const handleEdit = (management) => {
    setSelectedManagement(management);
    setIsEdit(true);
    setDialogOpen(true);
  };

  const handleAddNew = () => {
    setSelectedManagement(null);
    setIsEdit(false);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedManagement(null);
    setIsEdit(false);
  };

  const handleImport = () => {
    setImportDialogOpen(true);
  };

  const handleImportDialogClose = () => {
    setImportDialogOpen(false);
  };

  return (
    <React.Fragment>

      {(isAdmin && isActiveCompany) ?
        <div className="flex justify-between items-center mb-4 border-b pb-4">
          {/* Left: Title */}
          <p className="text-start text-[16px] font-semibold">
            Management
          </p>

          {/* Right: Search + Add Button */}
          <div className="flex items-center gap-3">


            {/* Add Management Button */}
            <BtnPrimary
              onClick={handleAddNew}
              className="text-md h-9 flex items-center justify-center px-3 gap-1 whitespace-nowrap"
            >
              Add Management

            </BtnPrimary>
            {/* Search */}
            <div className="input-wrapper relative">
              <div className="input-suffix-start absolute left-3.5 top-1/2 -translate-y-1/2">
                <img src="/assets/icons-svg/search-lg.svg" alt="" className="h-5" />
              </div>
              <ClientInput
                type="text"
                className="input pl-10 w-70 input-shadow h-10 text-sm border-gray-300 rounded-lg"
                placeholder="Search"
                inputchangehandler={inputchangehandler}
                name="search"
              />
            </div>
          </div>
        </div>



        : <><div className="flex justify-between mb-5">
          <div className="w-80 h-10 text-start">
            <Heading>Management</Heading>
          </div>
          <div>{isActiveCompany &&
            <BtnPrimary
              onClick={handleAddNew}
              className="text-xs h-9 flex items-center justify-center px-3 gap-1 whitespace-nowrap  "

            >
              Add Management
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.712 4.167v11.666M4.878 10h11.667"
                  stroke="#fff"
                  strokeWidth="1.667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </BtnPrimary>}</div>
          

        </div>
          <div className="flex justify-end mb-4">
            <div className="input-wrapper">
              <div className="input-suffix-start left-3.5">
                <img src="/assets/icons-svg/search-lg.svg" alt="" className="h-5" />
              </div>
              <ClientInput
                type="text"
                className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg"
                placeholder="Search"
                inputchangehandler={inputchangehandler}
                name={"search"}
              />
            </div>
          </div></>}




      <ManagementList
        sampleData={managementsData}
        onEdit={handleEdit}
        onDeleteSuccess={fetchManagementsList}
        loading={loading}
        companyData={companyData}
        currentPage={getFilterData.page}
        limit={getFilterData.limit}
      />


      {/* Add/Edit Dialog */}
      <AddEdit
        dialogOpen={dialogOpen}
        onDialogClose={handleDialogClose}
        managementData={selectedManagement}
        isEdit={isEdit}

        fetchManagements={fetchManagementsList}
      />

      {/* Import Dialog */}
      <ImportManagement
        dialogOpen={importDialogOpen}
        onDialogClose={handleImportDialogClose}

        fetchManagements={fetchManagementsList}
      />

      {/* Pagination */}
      <div className="flex justify-between items-center mt-3">
        <Pagination
          totalCount={totalCount}
          pageNumber={filterpage}
          displayPage={managementsData?.length}
          UpdatePageLimit={(newLimit) => {
            setfilterlimit(newLimit);
            setfilterpage(1);
            SetFilterData((prev) => ({
              ...prev,
              limit: newLimit,
              page: 1, // Updating this triggers your API call
            }));
          }}
          UpdatePage={handlePageChange}
        />

        {totalCount > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default Management;